import { useState } from "react";
import { traerNombresArchivos, descargarGaImagenes } from "../../apiClient/rutes/estudios";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { getTipoArchivo } from "./EstudiosPaciente-Utils";

export const useEstudiosPaciente = (mostrarNotificacion) => {
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [tituloPagina, setTituloPagina] = useState("");
  const [urlAxioPP, setUrlAxio] = useState("");
  const [estudioPdf, setEstudioPdf] = useState({ fecha: "", nombre: "", doc: {}, esLaboratorio: false, esEcografia: false });
  const [listadoEstudios, setListadoEstudios] = useState([]);
  const [listadoEstudiosFiltrados, setListadoEstudiosFiltrados] = useState([]);
  const [conjuntos, setConjuntos] = useState([]); // Mantenemos compatibilidad
  const [abrirModal, setAbrirModal] = useState(false);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });

  const abrirCerrarModal = () => setAbrirModal(!abrirModal);

  const traerEstudiosPaciente = async (paciente) => {
    let estudios = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = { headers: { Authorization: `Bearer ${paciente.token}` } };

    try {
      // Consultar carpeta 1 (Colposcopias)
      let responseCarpeta1 = { data: [] };
      try {
        const data1 = await traerNombresArchivos({
          token: paciente.token,
          documentoNro: paciente.documentoNro,
          carpeta: 1,
          urlAxioPP: url,
        });
        responseCarpeta1 = { data: data1 || [] };
      } catch (error) {
        console.warn("Error al cargar carpeta 1:", error);
      }

      // Consultar carpeta 2 (Histeroscopias)
      let responseCarpeta2 = { data: [] };
      try {
        const data2 = await traerNombresArchivos({
          token: paciente.token,
          documentoNro: paciente.documentoNro,
          carpeta: 2,
          urlAxioPP: url,
        });
        responseCarpeta2 = { data: data2 || [] };
      } catch (error) {
        console.warn("Error al cargar carpeta 2:", error);
      }

      // NUEVO: Consultar patologías desde base de datos
      let responsePatologias = { data: [] };
      try {
        responsePatologias = await axios.get(
          `${url}EstudiosImagenes/TraerPatologia?DocumentoPaciente=${paciente.documentoNro}`,
          config
        );
      } catch (patologiaError) {
        console.warn("Error al cargar patologías:", patologiaError);
      }

      // NUEVO: Consultar ecografías desde base de datos
      let responseEcografias = { data: [] };
      try {
        responseEcografias = await axios.get(
          `${url}EstudiosImagenes/TraerEcografiaPaciente?paciente=${paciente.codigo}`,
          config
        );
      } catch (ecografiaError) {
        console.warn("Error al cargar ecografías:", ecografiaError);
      }

      // NUEVO: Consultar Laboratorio desde API de LACE
      let responseLaboratorio = { data: null };
      try {
        const urlLace = `https://resultados.cloudlablace.com.ar:4443/gateway/integracion-api/v1/report?DocumentTypeId=1&DocumentNumber=${paciente.documentoNro}`;
        responseLaboratorio = await axios.get(urlLace, config);

        // Verificar si la respuesta es exitosa y tiene informes
        if (
          responseLaboratorio.data &&
          (responseLaboratorio.data.estado === "ok" || responseLaboratorio.data.estado === "Ok") &&
          responseLaboratorio.data.informes &&
          responseLaboratorio.data.informes.length > 0
        ) {
          console.log("Laboratorios encontrados para DNI:", paciente.documentoNro, "- Informes:", responseLaboratorio.data.informes.length);

          // Verificar si todos los informes son iguales (mismo base64)
          const informesUnicos = [];
          const base64Vistos = new Set();

          responseLaboratorio.data.informes.forEach((informe) => {
            const identificadorBase64 = informe.informeBase64 ? informe.informeBase64.substring(0, 100) : "";

            if (!base64Vistos.has(identificadorBase64) && informe.informeBase64) {
              base64Vistos.add(identificadorBase64);
              informesUnicos.push(informe);
            }
          });

          console.log("Informes únicos encontrados:", informesUnicos.length, "de", responseLaboratorio.data.informes.length, "totales");

          // Actualizar responseLaboratorio con solo informes únicos
          responseLaboratorio.data.informes = informesUnicos;
        } else {
          console.log("No se encontraron estudios de laboratorio para DNI:", paciente.documentoNro);
          
          // Fallback: intentar sin headers
          try {
            const responseSinHeaders = await axios.get(urlLace);
            if (
              responseSinHeaders.data &&
              (responseSinHeaders.data.estado === "ok" || responseSinHeaders.data.estado === "Ok") &&
              responseSinHeaders.data.informes &&
              responseSinHeaders.data.informes.length > 0
            ) {
              // Filtrar duplicados también en el fallback
              const informesUnicos = [];
              const base64Vistos = new Set();

              responseSinHeaders.data.informes.forEach((informe) => {
                const identificadorBase64 = informe.informeBase64 ? informe.informeBase64.substring(0, 100) : "";
                if (!base64Vistos.has(identificadorBase64) && informe.informeBase64) {
                  base64Vistos.add(identificadorBase64);
                  informesUnicos.push(informe);
                }
              });

              responseLaboratorio = { data: { ...responseSinHeaders.data, informes: informesUnicos } };
            }
          } catch (errorSinHeaders) {
            console.warn("Error en fallback de laboratorio:", errorSinHeaders);
          }
        }
      } catch (laboratorioError) {
        console.warn("Error al cargar laboratorios:", laboratorioError.message);
        responseLaboratorio = { data: null };
      }

      // Combinar estudios de ambas carpetas
      if (responseCarpeta1.data && responseCarpeta1.data.length > 0) {
        estudios = estudios.concat(
          responseCarpeta1.data.map((estudio) => ({
            ...estudio,
            carpeta: 1,
            tipoEstudio: "Colposcopia",
          }))
        );
      }
      if (responseCarpeta2.data && responseCarpeta2.data.length > 0) {
        estudios = estudios.concat(
          responseCarpeta2.data.map((estudio) => ({
            ...estudio,
            carpeta: 2,
            tipoEstudio: "Histeroscopia",
          }))
        );
      }

      // NUEVO: Agregar patologías desde base de datos
      if (responsePatologias.data && responsePatologias.data.length > 0) {
        const patologiasOrdenadas = responsePatologias.data.sort((a, b) => {
          const fechaA = new Date(a.fecha);
          const fechaB = new Date(b.fecha);
          return fechaB - fechaA;
        });

        estudios = estudios.concat(
          patologiasOrdenadas.map((patologia) => ({
            ...patologia,
            carpeta: 3,
            tipoEstudio: "Patología",
            esPatologia: true,
            fechaModificacion: null,
          }))
        );
      }

      // NUEVO: Agregar ecografías desde base de datos
      if (responseEcografias.data && responseEcografias.data.length > 0) {
        const ecografiasOrdenadas = responseEcografias.data.sort((a, b) => {
          const fechaA = new Date(a.fecha);
          const fechaB = new Date(b.fecha);
          return fechaB - fechaA;
        });

        estudios = estudios.concat(
          ecografiasOrdenadas.map((ecografia) => ({
            ...ecografia,
            carpeta: 4,
            tipoEstudio: "Ecografía",
            esEcografia: true,
            fechaModificacion: null,
          }))
        );
      }

      // NUEVO: Agregar Laboratorio desde API LACE
      if (
        responseLaboratorio.data &&
        (responseLaboratorio.data.estado === "ok" || responseLaboratorio.data.estado === "Ok") &&
        responseLaboratorio.data.informes &&
        responseLaboratorio.data.informes.length > 0
      ) {
        const informesLaboratorio = responseLaboratorio.data.informes.map((informe, index) => ({
          nombre: responseLaboratorio.data.informes.length > 1 ? `Informe de Laboratorio ${index + 1}` : "Informe de Laboratorio",
          codigo: `LAB${index + 1}`,
          carpeta: 5,
          tipoEstudio: "Laboratorio",
          esLaboratorio: true,
          fechaModificacion: null,
          documentoNro: paciente.documentoNro,
          informeBase64: informe.informeBase64,
          extension: informe.extension,
          fechaInforme: informe.fecha || "Sin fecha",
        }));

        estudios = estudios.concat(informesLaboratorio);
      }

      // Procesar estudios
      estudios = estudios.map((estudio, i) => {
        // NUEVO: Procesamiento específico para Laboratorio
        if (estudio.esLaboratorio) {
          let fechaFormateada = "No disponible";
          if (estudio.fechaInforme) {
            const fechaStr = estudio.fechaInforme;
            if (/^\d{8}$/.test(fechaStr)) {
              fechaFormateada = `${fechaStr.substr(0, 2)}/${fechaStr.substr(2, 2)}/${fechaStr.substr(4, 4)}`;
            } else {
              fechaFormateada = fechaStr;
            }
          }

          return {
            ...estudio,
            codigoUI: i,
            fecha: fechaFormateada,
            text: estudio.nombre || "Informe de Laboratorio",
            tipoEstudio: "Laboratorio",
            formato: estudio.extension || "pdf",
          };
        }

        // NUEVO: Procesamiento específico para patologías
        if (estudio.esPatologia) {
          let fechaFormateada = "No disponible";
          if (estudio.fecha) {
            fechaFormateada = dayjs(estudio.fecha).format("DD/MM/YYYY");
          }

          return {
            ...estudio,
            codigoUI: i,
            fecha: fechaFormateada,
            text: estudio.nombre ? estudio.nombre.replace(".pdf", "").replace(".PDF", "") : "Patología",
            tipoEstudio: "Patología",
            formato: getTipoArchivo(estudio.nombre) || "pdf",
          };
        }

        // NUEVO: Procesamiento específico para ecografías
        if (estudio.esEcografia) {
          let fechaFormateada = "No disponible";
          if (estudio.fecha) {
            fechaFormateada = dayjs(estudio.fecha).format("DD/MM/YYYY");
          }

          return {
            ...estudio,
            codigoUI: i,
            fecha: fechaFormateada,
            text: estudio.nombre || "Ecografía",
            tipoEstudio: "Ecografía",
            formato: "rtf",
          };
        }

        // Procesamiento existente para colpos e histeroscopias
        let nombre = estudio.nombre;
        nombre = nombre.replace(`${paciente.documentoNro}_`, "");
        nombre = nombre.replace(".pdf", "").replace(".PDF", "");

        let fechaParaMostrar;
        if (estudio.fechaModificacion) {
          fechaParaMostrar = dayjs(estudio.fechaModificacion).format("DD/MM/YYYY");
        } else {
          let fecha = dayjs(
            new Date(
              Number(nombre.substr(-8, 4)),
              Number(nombre.substr(-4, 2)) - 1,
              Number(nombre.substr(-2, 2))
            )
          );
          fechaParaMostrar = fecha.isValid() ? fecha.format("DD/MM/YYYY") : "No disponible";
        }

        let fecha = dayjs(
          new Date(
            Number(nombre.substr(-8, 4)),
            Number(nombre.substr(-4, 2)) - 1,
            Number(nombre.substr(-2, 2))
          )
        );

        if (fecha.isValid() && (fecha.isBefore(dayjs()) || dayjs().isSame(fecha))) {
          return {
            ...estudio,
            codigo: i,
            codigoUI: i,
            fecha: fechaParaMostrar,
            text: nombre.substr(0, nombre.substr(-11, 3) === " - " ? nombre.length - 11 : nombre.length - 8),
            carpeta: estudio.carpeta,
            tipoEstudio: estudio.tipoEstudio,
            formato: getTipoArchivo(estudio.nombre),
          };
        } else {
          return {
            ...estudio,
            codigo: i,
            codigoUI: i,
            fecha: fechaParaMostrar,
            text: nombre,
            carpeta: estudio.carpeta,
            tipoEstudio: estudio.tipoEstudio,
            formato: getTipoArchivo(estudio.nombre),
          };
        }
      });

      setListadoEstudios(estudios);
      setListadoEstudiosFiltrados(estudios);
      setConjuntos(estudios); // Para compatibilidad con la UI existente
    } catch (error) {
      mostrarNotificacion(true, "Error: " + (error.response?.data || error.message), "rojo");
    }
  };

  const BuscarEstudio = async (estudio, pdfDoc, pdfUrl, returnBlob) => {
    const urlAxioPP = localStorage.getItem("urlAxioPP");
    const config = { headers: { Authorization: `Bearer ${usuario.token}` } };
    
    try {
      let response;

      // NUEVO: Para laboratorio, mostrar PDF base64 en modal
      if (estudio.esLaboratorio) {
        if (estudio.informeBase64) {
          setEstudioPdf({
            fecha: estudio.fecha || "Sin fecha",
            nombre: estudio.text || "Informe de Laboratorio",
            doc: estudio.informeBase64,
            esLaboratorio: true,
            esEcografia: false,
          });
          abrirCerrarModal();
        } else {
          mostrarNotificacion(true, "No se pudo cargar el informe de laboratorio", "rojo");
        }
        return;
      }

      // NUEVO: Para ecografías, mostramos el contenido RTF directamente
      if (estudio.esEcografia) {
        setEstudioPdf({
          fecha: estudio.fecha || "Sin fecha",
          nombre: estudio.nombre || estudio.text,
          doc: estudio.documento,
          esEcografia: true,
          esLaboratorio: false,
        });
        abrirCerrarModal();
        return;
      }

      // NUEVO: Para patologías, usar endpoint específico
      if (estudio.esPatologia) {
        response = await axios.request({
          url: `${urlAxioPP}EstudiosImagenes/DescargarPatologia?codigo=${estudio.codigo}`,
          method: "GET",
          responseType: "blob",
          headers: config.headers,
        });
      } else {
        // Lógica existente para colpos e histeroscopias
        const nombreArchivoApi = estudio.nombreArchivo || estudio.nombre;
        const blob = await descargarGaImagenes({
          token: usuario.token,
          documentoNro: usuario.documentoNro,
          nombreArchivo: nombreArchivoApi,
          formato: estudio.formato,
          carpeta: estudio.carpeta,
          urlAxioPP,
        });
        response = { data: blob };
      }

      if (response.data && response.data.size > 0) {
        if ((pdfDoc && !pdfUrl) || returnBlob) {
          let file = new Blob([response.data]);
          if (returnBlob) return file;
          let fileURL = URL.createObjectURL(file);
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.download = `${estudio.text}.${estudio.formato}`;
          fileLink.click();
        } else {
          // Visualización
          const fileURL = URL.createObjectURL(response.data);
          if (!pdfDoc && pdfUrl) {
            setEstudioPdf({
              fecha: estudio.fecha,
              nombre: estudio.text,
              doc: fileURL,
              esLaboratorio: false,
              esEcografia: false,
            });
            abrirCerrarModal();
          }
        }
      }
    } catch (error) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar buscar el estudio seleccionado: " + (error.response?.status || error.message),
        "rojo"
      );
    }

    return null;
  };

  const DescargarPdf = (estudio) => {
    setCargando(true);
    if (estudio) {
      // No permitir descarga de laboratorios y ecografías (solo visualización)
      if (!estudio.esLaboratorio && !estudio.esEcografia) {
        BuscarEstudio(estudio, true, false, false);
      } else {
        mostrarNotificacion(true, "Este tipo de estudio solo puede ser visualizado", "rojo");
      }
    } else {
      mostrarNotificacion(true, "Estudio sin archivo guardado", "rojo");
    }
    setCargando(false);
  };

  const DescargarConjuntoArchivos = async (conjunto) => {
    setCargando(true);
    const zip = new JSZip();
    if (conjunto) {
      const conjuntoDescargar = conjuntos.find((conjuntoTmp) => conjuntoTmp.fecha === conjunto.fecha);
      try {
        const blobs = await Promise.all(
          conjuntoDescargar.estudios.map((estudio) =>
            BuscarEstudio(estudio, false, true, true).then((blob) => ({ nombre: estudio.nombre, blob }))
          )
        );
        blobs.forEach(({ nombre, blob }) => {
          if (blob) {
            zip.file(nombre, blob);
          }
        });
        const content = await zip.generateAsync({ type: "blob" });
        saveAs(content, `Conjunto_estudios_${conjuntoDescargar.fecha}.zip`);
      } catch (err) {
        mostrarNotificacion(true, "Error al generar el ZIP", "rojo");
      }
    } else {
      mostrarNotificacion(true, "Conjunto no encontrado", "rojo");
    }
    setCargando(false);
  };

  const VisualizarPdf = (estudio) => {
    setCargando(true);
    if (estudio) {
      if (estudio.esLaboratorio) {
        BuscarEstudio(estudio, false, false, false); // Sin parámetros PDF
      } else {
        BuscarEstudio(estudio, false, true, false);
      }
    } else {
      mostrarNotificacion(true, "Estudio sin archivo guardado", "rojo");
    }
    setCargando(false);
  };

  return {
    usuario, setUsuario,
    cargando, setCargando,
    tituloPagina, setTituloPagina,
    urlAxioPP, setUrlAxio,
    estudioPdf, setEstudioPdf,
    listadoEstudios, setListadoEstudios,
    listadoEstudiosFiltrados, setListadoEstudiosFiltrados,
    conjuntos, setConjuntos,
    abrirModal, setAbrirModal,
    toast, setToast,
    abrirCerrarModal,
    traerEstudiosPaciente,
    BuscarEstudio,
    DescargarPdf,
    DescargarConjuntoArchivos,
    VisualizarPdf,
  };
};
